import { once } from 'lodash'
import * as React from 'react'
import { Waypoint } from 'react-waypoint'
import styled from 'styled-components'
import I18n from '../../../../core/i18n'
import { postService } from '../../../../core/services'
import * as constants from '../../../../static/constants'
import * as interfaces from '../../../../static/interfaces'
import { Spinner } from '../../../atoms'
import { PostCard } from 'components/molecules'
import { checkLikeable } from 'utils'
import { Swiper, SwiperSlide } from 'swiper/react'

interface IProps {
  post: any
  user: interfaces.IUser
}

export const RelatedPosts: React.FC<IProps> = ({ post, user }) => {
  const [relatedPosts, setRelatedPosts] = React.useState<null | any[]>(null)

  const getRelatedPosts = async () => {
    try {
      const data = await postService.getRelatedPosts(post)
      setRelatedPosts(data.relatedPosts)
    } catch (e) {
      setRelatedPosts([])
    }
  }
  return (
    <Waypoint onEnter={once(getRelatedPosts)}>
      <RelatedPostsWrapper>
        <h2>{I18n.t('post.related_posts')}</h2>
        {relatedPosts === null && (
          <div className="RelatedPosts_Loading">
            <Spinner />
          </div>
        )}
        {relatedPosts && relatedPosts.length > 0 && (
          <div className="RelatedPosts_Inner">
            <Swiper
              slidesPerView={'auto'}
              slidesPerGroup={1}
              spaceBetween={20}
              slidesOffsetBefore={16}
              slidesOffsetAfter={16}
              breakpoints={{
                720: {
                  slidesPerView: 3,
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: 0,
                },
                960: {
                  slidesPerView: 4,
                  slidesOffsetBefore: 0,
                  slidesOffsetAfter: 0,
                },
              }}
              rewind={true}
            >
              {relatedPosts.map(relatedPost => (
                <SwiperSlide key={relatedPost.id}>
                  <PostCard post={relatedPost} likeable={checkLikeable(relatedPost, user)} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
      </RelatedPostsWrapper>
    </Waypoint>
  )
}

const RelatedPostsWrapper = styled.div`
  max-width: 112rem;
  margin: 0 auto 4.8rem;
  padding: 0 0 4.8rem;
  overflow: hidden;
  background-color: white;
  @media (max-width: ${constants.BREAKPOINT_DESKTOP_LARGE}px) {
    max-width: none;
    padding: 0 8rem;
  }
  @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
    padding: 0 5rem;
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    padding: 0;
  }

  > h2 {
    line-height: 4.4rem;
    margin-bottom: 2.4rem;
    font-size: 3rem;
    @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
      line-height: 3.2rem;
      margin-bottom: 1.6rem;
      font-size: 2rem;
      padding-top: 2.4rem;
      border-top: 1px solid ${constants.COLORS.divider2};
    }
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      margin: 0 1.6rem 1.6rem;
    }
  }

  .RelatedPosts_Loading {
    margin: 32px 0;
  }

  .RelatedPosts_Inner {
    position: relative;
    & + & {
      margin-top: 90px;
    }
  }
  .swiper-slide {
    height: auto;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 240px;
    }
    > a {
      height: 100%;
    }
  }
`
